export const creditPurposeData = {
  purpose: {
    value: 'Money',
    label: 'Кредит наличными',
    data: {
      alias: 'Money',
    },
  },
  initialFee: '',
  period: { name: '5 лет', value: 'P5Y' },
  amount: 500_000,
  autoModel: null,
  autoBrand: null,
};
